export { default as identity } from "./identity";
export { default as noop } from "./noop";

export function isNotDefined(d) {
	return !isDefined(d);
}

export function isDefined(d) {
	return d !== null && typeof d != "undefined";
}

export function functor(v) {
	return typeof v === "function" ? v : () => v;
}

export function find(list, predicate, context = this) {
	for (let i = 0; i < list.length; ++i) {
		if (predicate.call(context, list[i], i, list)) {
			return list[i];
		}
	}
	return undefined;
}